module.exports = __webpack_public_path__ + "static/img/logo_01.9e44266.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/logo_01.jpg
// module id = Ntlt
// module chunks = 1